<template>
  <div class="create-delivery">
    <form @submit.prevent="createDeliveryHandler">
      <div class="form-items">
        <div>
          <label>Дата</label>
          <date-picker
            v-model="range"
            :min-date="new Date()"
            :select-attribute="selectDragAttribute"
            :drag-attribute="selectDragAttribute"
            is-range
            :model-config="modelConfig"
            locale="ru"
            @drag="dateRange = $event"
          >
            <template v-slot:day-popover="{ format }">
              <div>
                {{ format(dateRange ? dateRange.start : range.start, "MMM D") }}
                -
                {{ format(dateRange ? dateRange.end : range.end, "MMM D") }}
              </div>
            </template>
          </date-picker>
        </div>
        <div>
          <va-checkbox
            v-model="delivery.deliveryIsDisabled"
            class="mb-0"
            :label="'Запретить день для заказа'"
          />
        </div>
        <div v-if="!delivery.deliveryIsDisabled">
          <label>Часовой интервал</label>
          <select
            v-model="timePrecisionValue"
            class="form-control form-control--delivery"
          >
            <option
              v-for="opt in timePrecisions"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.name }}
            </option>
          </select>
        </div>
        <div v-if="!delivery.deliveryIsDisabled" class="form-child-items">
          <div class="row">
            <va-input :value="timeFromBoundary" :disabled="true" />
            <va-input :value="timeToBoundary" :disabled="true" />
          </div>
          <div>
            <label
              >{{ timePrecisionValue }}-часовой интервал (минуты не
              учитываются)</label
            >
            <div class="four-hour-intervals">
              <date-picker
                v-model="delivery.timeFromBoundary"
                locale="ru"
                mode="time"
              />

              <date-picker
                v-model="delivery.timeToBoundary"
                locale="ru"
                mode="time"
              />
            </div>
          </div>
          <div>
            <label>Дневная стоимость</label>
            <va-input
              v-model="delivery.dayMarkup"
              type="number"
              placeholder="Стоимость"
            />
          </div>
          <div>
            <label>Ночная стоимость</label>
            <va-input
              v-model="delivery.nightMarkup"
              type="number"
              placeholder="Стоимость"
            />
          </div>
          <div>
            <label>Надбавка за диапазон времени</label>
            <va-input
              v-model="delivery.rangeTimeMarkup"
              type="number"
              placeholder="Надбавка за диапазон времени"
            />
          </div>
          <div>
            <label>Надбавка за точное время</label>
            <va-input
              v-model="delivery.exactTimeMarkup"
              type="number"
              placeholder="Надбавка за точное время"
            />
          </div>
          <div>
            <label>Надбавка за км</label>
            <va-input
              v-model="delivery.markupPerKm"
              type="number"
              placeholder="Надбавка за км"
            />
          </div>
        </div>
      </div>
      <div class="mt-4 text-center">
        <va-button type="button" color="primary" @click="$emit('close')">
          Отменить
        </va-button>
        <va-button color="info" type="submit"> Сохранить </va-button>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import api from "@/api/axios";
import { mapActions } from "vuex";
import { Calendar } from "v-calendar";
Vue.component("date-picker", Calendar);
export default {
  name: "CreateDelivery",
  data() {
    return {
      timePrecisions: [
        { name: "2-часовой интервал", value: 2 },
        { name: "4-часовой интервал", value: 4 },
        { name: "6-часовой интервал", value: 6 },
      ],
      timePrecisionValue: 2,
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD",
      },
      dateRange: null,
      range: {
        start: new Date(),
        end: new Date(),
      },
      mode: "",
      date: new Date(),
      delivery: {
        deliveryIsDisabled: false,
        timeFromBoundary: new Date(),
        timeToBoundary: new Date(),
        dayMarkup: "",
        nightMarkup: "",
        rangeTimeMarkup: "",
        exactTimeMarkup: "",
        markupPerKm: "",
      },
    };
  },
  computed: {
    selectDragAttribute() {
      return {
        popover: {
          visibility: "hover",
          isInteractive: false, // Defaults to true when using slot
        },
      };
    },
    timeToBoundary() {
      return this.$dayjs(this.delivery.timeToBoundary).format("HH:00");
    },
    timeFromBoundary() {
      return this.$dayjs(this.delivery.timeFromBoundary).format("HH:00");
    },
  },
  methods: {
    ...mapActions("delivery", ["getDeliveryList"]),
    async createDeliveryHandler() {
      const {
        timeFromBoundary,
        timeToBoundary,
        dayMarkup,
        nightMarkup,
        markupPerKm,
        rangeTimeMarkup,
        exactTimeMarkup,
        deliveryIsDisabled,
      } = this.delivery;
      const data = {
        date_from: this.range.start,
        date_to: this.range.end,
        exact_time_markup: exactTimeMarkup,
        range_time_markup: rangeTimeMarkup,
        delivery_is_disabled: deliveryIsDisabled,
        day_markup: dayMarkup,
        night_markup: nightMarkup,
        markup_per_km: markupPerKm,
        time_from_boundary: this.$dayjs(timeFromBoundary).format("HH:00"),
        time_to_boundary: this.$dayjs(timeToBoundary).format("HH:00"),
        time_precision: this.timePrecisionValue,
      };
      try {
        await api.post("/admin/delivery-settings", data).then(() => {
          this.$emit("close");
        });
        await this.getDeliveryList({ page: 1 });
      } catch (error) {
        const errors = Object.values(error.response.data.errors).flat();
        this.$notify({
          type: "error",
          title: errors.join(", "),
        });
        return error;
      }
    },
  },
};
</script>

<style lang="scss">
.create-delivery {
  .form-items,
  .form-child-items {
    display: grid;
    gap: 20px;
  }
  label {
    display: block;
  }
}
.four-hour-intervals {
  display: flex;
  gap: 10px;
}
.form-control--delivery {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
